import React, { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import Loader from '../components/Loader'
import { lambda, setSecureCookie } from '../Functions';

export default function Signin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showResetPopup, setShowResetPopup] = useState(false);
  const [resetEmail, setResetEmail] = useState('');

  const [resetMessage, setResetMessage] = useState('');
  const [resetLoading, setResetLoading] = useState(false);

  const handleSignIn = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${lambda}?action=signin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();
      console.log(data);

      if (data.error) {
        setError("Invalid username or password");
      } else {
        setSecureCookie("gbx_id", data.user.id, 7);
        sessionStorage.setItem("gbx_data", JSON.stringify(data));

        let params = new URLSearchParams(document.location.search);
        let sid = params.get("sid"); // is the string "Jonathan"
        let pid = params.get("pid"); // is the number 18

        if(sid && pid){
          window.location.href = `/checkout?sid=${sid}&pid=${pid}`;
        }else{
          window.location.href = '/';
        }
      }
    } catch (err) {
      console.error("Error signing in:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {

 
    setResetMessage('');

    if(resetEmail===""){
      setResetMessage('Please enter your email');
    }else{
      setResetLoading(true);
      try {
        const response = await fetch(`${lambda}?action=ResetPassword`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: resetEmail })
        });
  
        const data = await response.json();
        if (data.success) {
          setResetMessage("A password reset link has been sent to your email.");
        } else {
          setResetMessage(data.message || "Failed to send reset link.");
        }
      } catch (error) {
        console.error("Error sending reset request:", error);
        setResetMessage("An error occurred. Please try again.");
      } finally {
        setResetLoading(false);
      }

    }
    
  };

  return (
    <div>
      <Navbar />

      <section className="d-flex flex-column align-items-center justify-content-center mt-5">
        <div className="auth_form bg_purple_light mt-12 p-5">
          <h2 className="pb-4">Login</h2>

          {error && (
            <div className="alert alert-danger text-center p-2" style={{ borderRadius: '5px' }}>
              {error}
            </div>
          )}

          <div>
            <div className="d-flex flex-column mt-2">
              <label className="bold">Email Address:</label>
              <input type="text" name="email" onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="d-flex flex-column mt-3">
              <label className="bold">Password:</label>
              <input type="password" name="password" onChange={(e) => setPassword(e.target.value)} />
            </div>

            <div className="mt-2 d-flex flex-row flex-wrap justify-content-between">
              <p className="text-dark" style={{ cursor: 'pointer' }} onClick={() => setShowResetPopup(true)}>Forgot Password?</p>
              <p className="text-dark">
                Don't have an account?
                <span className="bold" style={{ cursor: 'pointer' }} onClick={() => window.location.href = '/signup'}> Sign Up</span>
              </p>
            </div>

            <button
              className="home_button_purple mt-4"
              onClick={handleSignIn}
              style={{ width: '150px', float: 'right', fontSize: '1.5rem' }}
              disabled={loading}
            >
              {loading ? <p>Sign in <Loader/></p>: 'Sign In'}
            </button>
          </div>
        </div>
      </section>




      {/* Password Reset Popup */}
      {showResetPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <h4 className='bold'>Reset Password</h4>
            <p className='text-dark' >Enter your email to receive a reset link.</p>
            <input
              type="email"
              className="reset-input"
              placeholder="Enter your email"
              value={resetEmail}
             
              onChange={(e) => setResetEmail(e.target.value)}
            />
            {resetMessage && <p className="reset-message">{resetMessage}</p>}
            <div className="popup-buttons">
              <button onClick={handlePasswordReset} disabled={resetLoading} className="reset-btn">
                {resetLoading ? 'Sending...' : 'Submit'}
              </button>
              <button onClick={() => setShowResetPopup(false)} className="cancel-btn">Close</button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
